// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  E.g. 
  @include mix.position-fix(-15px, 0 0 -15px 0);
  @include mix.respond(1280px) { @include mix.position-reset(); }
*/
.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

.display-flex {
  display: flex !important;
}

.display-block {
  display: block !important;
}

.display-inline-block {
  display: inline-block !important;
}

.display-grid {
  display: grid !important;
}

.display-inline {
  display: inline !important;
}

.display-inline-flex {
  display: inline-flex !important;
}

.display-none {
  display: none !important;
}

.direction-column {
  flex-direction: column;
}

.align-items-start {
  align-items: flex-start !important;
}
.align-items-center {
  align-items: center !important;
}
.align-items-end {
  align-items: flex-end !important;
}
.align-items-stretch {
  align-items: stretch !important;
}
.align-items-baseline {
  align-items: baseline !important;
}
.align-content-start {
  align-content: flex-start !important;
}
.align-content-center {
  align-content: center !important;
}
.align-content-end {
  align-content: flex-end !important;
}
.align-content-stretch {
  align-content: stretch !important;
}
.align-content-baseline {
  align-content: baseline !important;
}
.align-content-between {
  align-content: space-between !important;
}
.align-content-around {
  align-content: space-around !important;
}
.align-self-start {
  align-self: flex-start !important;
}
.align-self-center {
  align-self: center !important;
}
.align-self-end {
  align-self: flex-end !important;
}
.align-self-stretch {
  align-self: stretch !important;
}
.align-self-baseline {
  align-self: baseline !important;
}

.justify-items-start {
  justify-items: flex-start !important;
}
.justify-items-center {
  justify-items: center !important;
}
.justify-items-end {
  justify-items: flex-end !important;
}
.justify-items-stretch {
  justify-items: stretch !important;
}
.justify-items-baseline {
  justify-items: baseline !important;
}
.justify-content-start {
  justify-content: flex-start !important;
}
.justify-content-center {
  justify-content: center !important;
}
.justify-content-end {
  justify-content: flex-end !important;
}
.justify-content-stretch {
  justify-content: stretch !important;
}
.justify-content-baseline {
  justify-content: baseline !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-around {
  justify-content: space-around !important;
}
.justify-self-start {
  justify-content: flex-start !important;
}
.justify-self-center {
  justify-content: center !important;
}
.justify-self-end {
  justify-content: flex-end !important;
}
.justify-self-stretch {
  justify-content: stretch !important;
}
.justify-self-baseline {
  justify-content: baseline !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}
.flex-1 {
  flex: 1 !important;
}

.position-relative {
  position: "relative" !important;
}

.position-absolute {
  position: "absolute" !important;
}

.position-fixed {
  position: "fixed" !important;
}

.position-static {
  position: "static" !important;
}

.background-color--white {
  background-color: white !important;
}
.background-color--primary {
  background-color: #2f3164 !important;
}
.background-color--secondary {
  background-color: #2f3164 !important;
}
.background-color--success {
  background-color: #becdae !important;
}
.background-color--muted {
  background-color: #e6e6e6 !important;
}
.background-color--danger {
  background-color: #b3002d !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-fit {
  width: -moz-fit-content !important;
  width: fit-content !important;
}

.card-spacing-top {
  margin-top: 15px !important;
}
.card-spacing-bottom {
  margin-bottom: 15px !important;
}

.line-height-16 {
  line-height: 1.6;
}

.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.text-xs {
  font-size: 10px !important;
}
.text-sm {
  font-size: 14px !important;
}
.text-md {
  font-size: 15px !important;
}
.text-nrm {
  font-size: 16px !important;
}
.text-lg {
  font-size: 20px !important;
}
.text-normal {
  font-style: normal !important;
}
.text-italic {
  font-style: italic !important;
}
.text-normal {
  font-weight: 400 !important;
}
.text-semibold {
  font-weight: 600 !important;
}
.text-cap {
  text-transform: capitalize !important;
}
.text-upper {
  text-transform: uppercase !important;
}
.text-lower {
  text-transform: lowercase !important;
}
.text-white {
  color: #fff !important;
}
.text-black {
  color: rgba(0, 0, 0, 0.87) !important;
}
.text-link {
  color: #0000ff;
  cursor: pointer;
}
.text-primary {
  color: #2f3164 !important;
}
.text-success {
  color: hsl(109, 56%, 25%) !important;
}
.text-danger {
  color: #b3002d !important;
}
.text-muted {
  color: rgba(0, 0, 0, 0.54);
}
.text-underline {
  text-decoration: underline !important;
}
.text-underline-none {
  text-decoration: none !important;
}

.border-0 {
  border-width: 0 !important;
}
.border-none {
  border: 0px solid transparent !important;
}

.cursor-pointer {
  cursor: pointer;
}

.page-bottom-leeway {
  margin-bottom: 200px;
}

.transition-default {
  transition: 0.2s ease;
}

.overflow-hidden {
  overflow: hidden !important;
}
.overflow-visible {
  overflow: visible !important;
}
.overflow-auto {
  overflow: auto !important;
}

.box-shadow--normal {
  box-shadow: 0 0 41px -19px rgba(47, 49, 100, 0.3) !important;
}

.mat-mdc-form-field-error {
  font-size: 12px;
}

.mat-mdc-dialog-content {
  padding: 0;
  padding-right: 24px;
}

.help {
  display: flex;
}
.help__search {
  background-color: #f1f1f1;
  flex: 25%;
  min-width: 200px;
  padding: 0 24px;
  width: 100%;
}
.help__search-input {
  padding-top: 2rem;
}
.help__search-list {
  list-style-type: none;
  overflow-y: auto;
  max-height: 400px;
  padding: 0;
}
.help__search-list::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.help__search-list::-webkit-scrollbar-track {
  background: rgb(219.3, 219.3, 219.3);
}
.help__search-list::-webkit-scrollbar-thumb {
  background-color: rgb(158.1, 158.1, 158.1);
}
.help__search-item {
  cursor: pointer;
  padding: 0.75em 0;
}
.help__search-item:not(:last-child) {
  border-bottom: 1px solid #d3d3d3;
}
.help__search-item:first-child {
  padding-top: 0;
}
.help__search-item:last-child {
  padding-bottom: 0;
}
.help__search-item--selected {
  font-weight: 500;
}
.help__search-item--none {
  font-style: italic;
  color: rgb(24, 24, 24);
}
.help__result {
  flex: 75%;
  padding: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/abstracts/_mixins.scss","webpack://./node_modules/@angular/material/core/_core.scss","webpack://./src/app/shared/modals/help-modal/help-modal.component.scss","webpack://./src/styles/abstracts/_utilities.scss"],"names":[],"mappings":"AAyBE;;;;CAAA;ACmBI;EACE,yJAAA;ACtCR;;ADqCM;EACE,0JAAA;AClCR;;ADiCM;EACE,0JAAA;AC9BR;;AD6BM;EACE,0JAAA;AC1BR;;ADyBM;EACE,2JAAA;ACtBR;;ADqBM;EACE,2JAAA;AClBR;;ADiBM;EACE,4JAAA;ACdR;;ADaM;EACE,4JAAA;ACVR;;ADSM;EACE,4JAAA;ACNR;;ADKM;EACE,4JAAA;ACFR;;ADCM;EACE,8JAAA;ACER;;ADHM;EACE,8JAAA;ACMR;;ADPM;EACE,8JAAA;ACUR;;ADXM;EACE,8JAAA;ACcR;;ADfM;EACE,8JAAA;ACkBR;;ADnBM;EACE,8JAAA;ACsBR;;ADvBM;EACE,+JAAA;AC0BR;;AD3BM;EACE,+JAAA;AC8BR;;AD/BM;EACE,+JAAA;ACkCR;;ADnCM;EACE,+JAAA;ACsCR;;ADvCM;EACE,gKAAA;AC0CR;;AD3CM;EACE,gKAAA;AC8CR;;AD/CM;EACE,gKAAA;ACkDR;;ADnDM;EACE,gKAAA;ACsDR;;ADvDM;EACE,gKAAA;AC0DR;;ADvFE;EACE,6BAAA;AC0FJ;;ADnFI;EACE,yFAAA;EACA,uEAAA;ACsFN;;AFpGI;EGDE,wBAAA;ADyGN;;AFxGI;EGDE,yBAAA;AD6GN;;AF5GI;EGDE,gCAAA;ADiHN;;AFhHI;EGDE,wBAAA;ADqHN;;AFpHI;EGDE,0BAAA;ADyHN;;AFxHI;EGDE,+BAAA;AD6HN;;AF5HI;EGDE,wBAAA;ADiIN;;AFhII;EGMA,sBAAA;AD8HJ;;AFpII;EGaE,kCAAA;AD2HN;AFxII;EGgBE,8BAAA;AD2HN;AF3II;EGmBE,gCAAA;AD2HN;AF9II;EGsBE,+BAAA;AD2HN;AFjJI;EGyBE,gCAAA;AD2HN;AFpJI;EG8BE,oCAAA;ADyHN;AFvJI;EGiCE,gCAAA;ADyHN;AF1JI;EGoCE,kCAAA;ADyHN;AF7JI;EGuCE,iCAAA;ADyHN;AFhKI;EG0CE,kCAAA;ADyHN;AFnKI;EG6CE,uCAAA;ADyHN;AFtKI;EGgDE,sCAAA;ADyHN;AFzKI;EGqDE,iCAAA;ADuHN;AF5KI;EGwDE,6BAAA;ADuHN;AF/KI;EG2DE,+BAAA;ADuHN;AFlLI;EG8DE,8BAAA;ADuHN;AFrLI;EGiEE,+BAAA;ADuHN;;AFxLI;EGyEE,oCAAA;ADmHN;AF5LI;EG4EE,gCAAA;ADmHN;AF/LI;EG+EE,kCAAA;ADmHN;AFlMI;EGkFE,iCAAA;ADmHN;AFrMI;EGqFE,kCAAA;ADmHN;AFxMI;EG0FE,sCAAA;ADiHN;AF3MI;EG6FE,kCAAA;ADiHN;AF9MI;EGgGE,oCAAA;ADiHN;AFjNI;EGmGE,mCAAA;ADiHN;AFpNI;EGsGE,oCAAA;ADiHN;AFvNI;EGyGE,yCAAA;ADiHN;AF1NI;EG4GE,wCAAA;ADiHN;AF7NI;EGiHE,sCAAA;AD+GN;AFhOI;EGoHE,kCAAA;AD+GN;AFnOI;EGuHE,oCAAA;AD+GN;AFtOI;EG0HE,mCAAA;AD+GN;AFzOI;EG6HE,oCAAA;AD+GN;;AF5OI;EGoIA,0BAAA;AD4GJ;AFhPI;EGwIA,kBAAA;AD2GJ;;AFnPI;EGgJE,+BAAA;ADuGN;;AFvPI;EGgJE,+BAAA;AD2GN;;AF3PI;EGgJE,4BAAA;AD+GN;;AF/PI;EGgJE,6BAAA;ADmHN;;AFxQI;EG6JE,kCAAA;AD+GN;AF5QI;EGiKE,oCAAA;AD8GN;AF/QI;EGqKE,oCAAA;AD6GN;AFlRI;EG0KE,oCAAA;AD2GN;AFrRI;EG8KE,oCAAA;AD0GN;AFxRI;EGkLE,oCAAA;ADyGN;;AFtRI;EG4LE,qBAAA;AD8FN;;AF1RI;EG4LE,qBAAA;ADkGN;;AF9RI;EG4LE,qBAAA;ADsGN;;AFlSI;EG4LE,sBAAA;AD0GN;;AFtSI;EG4LE,kCAAA;EAAA,6BAAA;AD8GN;;AF1SI;EGoME,2BAAA;AD0GN;AF9SI;EGwME,8BAAA;ADyGN;;AFjTI;EG+MA,gBAAA;ADsGJ;;AFrTI;EGwNE,2BAAA;ADiGN;AFzTI;EGwNE,6BAAA;ADoGN;AF5TI;EGwNE,4BAAA;ADuGN;AF/TI;EGqOE,0BAAA;AD6FN;AFlUI;EGqOE,0BAAA;ADgGN;AFrUI;EGqOE,0BAAA;ADmGN;AFxUI;EGqOE,0BAAA;ADsGN;AF3UI;EGqOE,0BAAA;ADyGN;AF9UI;EG4OE,6BAAA;ADqGN;AFjVI;EG4OE,6BAAA;ADwGN;AFpVI;EGsPE,2BAAA;ADiGN;AFvVI;EGsPE,2BAAA;ADoGN;AF1VI;EGiQE,qCAAA;AD4FN;AF7VI;EGiQE,oCAAA;AD+FN;AFhWI;EGiQE,oCAAA;ADkGN;AFnWI;EGsQA,sBAAA;ADgGJ;AFtWI;EGyQA,qCAAA;ADgGJ;AFzWI;EG4QA,cAAA;EACA,eAAA;ADgGJ;AF7WI;EGgRA,yBAAA;ADgGJ;AFhXI;EGmRA,oCAAA;ADgGJ;AFnXI;EGsRA,yBAAA;ADgGJ;AFtXI;EGyRA,0BAAA;ADgGJ;AFzXI;EG6RA,qCAAA;AD+FJ;AF5XI;EGgSE,gCAAA;AD+FN;;AF/XI;EGwSA,0BAAA;AD2FJ;AFnYI;EG4SA,wCAAA;AD0FJ;;AFtYI;EGmTA,eAAA;ADuFJ;;AF1YI;EG2TE,oBAAA;ADmFN;;AF9YI;EGkUA,qBAAA;ADgFJ;;AFlZI;EG0UE,2BAAA;AD4EN;AFtZI;EG0UE,4BAAA;AD+EN;AFzZI;EG0UE,yBAAA;ADkFN;;AFjaI;EGsVA,4DAAA;AD+EJ;;AC1EA;EACE,eAAA;AD6EF;;AA3aA;EACI,UAAA;EACA,mBAAA;AA8aJ;;AA3aA;EACE,aAAA;AA8aF;AFvbI;EEYA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA8aJ;AFpbI;EESE,iBAAA;AA8aN;AFvbI;EEaE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AA6aN;AClGE;EACE,WAAA;EACA,YAAA;ADoGJ;ACjGE;EACE,oCAAA;ADmGJ;AChGE;EACE,0CAAA;ADkGJ;AFvcI;EEuBE,eAAA;EACA,iBAAA;AAmbN;AAjbM;EACE,gCAAA;AAmbR;AAhbM;EACE,cAAA;AAkbR;AA/aM;EACE,iBAAA;AAibR;AFzdI;EE4CI,gBAAA;AAgbR;AF5dI;EEgDI,kBAAA;EACA,sBAAA;AA+aR;AFreI;EE4DA,SAAA;EACA,aAAA;AA4aJ","sourcesContent":["// BEM Mixins\r\n@mixin e($element) {\r\n    &__#{$element} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin m($modifier) {\r\n    &--#{$modifier} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin c($child) {\r\n    &-#{$child} {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Media Query Mixin\r\n  @mixin respond($respond) {\r\n    @media only screen and (max-width: #{$respond}) {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Position fixing (generally used for forms)\r\n  /*\r\n    E.g. \r\n    @include mix.position-fix(-15px, 0 0 -15px 0);\r\n    @include mix.respond(1280px) { @include mix.position-reset(); }\r\n  */\r\n  @mixin position-fix($top, $margin: 0 0 0 0) {\r\n    margin: $margin;\r\n    position: relative;\r\n    top: $top;\r\n  }\r\n  \r\n  @mixin position-reset() {\r\n    margin: 0;\r\n    position: static;\r\n    top: 0;\r\n  }","@use './m3-app';\n@use './tokens/token-utils';\n@use './style/elevation';\n\n$fallbacks: m3-app.get-tokens();\n\n/// @deprecated This mixin is a no-op and is going to be removed in v21.\n@mixin core() {}\n\n// Emits the mat-app-background CSS class. This predefined class sets the\n// background color and text color of an element.\n@mixin app-background() {\n  // TODO: Move ripple styles to be dynamically loaded instead of in core.\n  // This variable is used as a fallback for the ripple element's\n  // background color. However, if it isn't defined anywhere, then MSS\n  // complains in its verification stage.\n  html {\n    --mat-sys-on-surface: initial;\n  }\n\n  // Wrapper element that provides the theme background when the\n  // user's content isn't inside of a `mat-sidenav-container`.\n  @at-root {\n    // Note: we need to emit fallback values here to avoid errors in internal builds.\n    .mat-app-background {\n      background-color: token-utils.slot(app-background-color, $fallbacks, transparent);\n      color: token-utils.slot(app-text-color, $fallbacks, inherit);\n    }\n  }\n}\n\n// Emits CSS classes for applying elevation. These classes follow the pattern\n// mat-elevation-z#, where # is the elevation number you want, from 0 to 24.\n// These predefined classes use the CSS box-shadow settings defined by the\n// Material Design specification.\n@mixin elevation-classes() {\n  @at-root {\n    // Provides external CSS classes for each elevation value. Each CSS class is formatted as\n    // `mat-elevation-z$z-value` where `$z-value` corresponds to the z-space to which the element\n    // is elevated.\n    @for $z-value from 0 through 24 {\n      $selector: elevation.$prefix + $z-value;\n      // We need the `mat-mdc-elevation-specific`, because some MDC mixins\n      // come with elevation baked in and we don't have a way of removing it.\n      .#{$selector}, .mat-mdc-elevation-specific.#{$selector} {\n        box-shadow: token-utils.slot('app-elevation-shadow-level-#{$z-value}', $fallbacks, none);\n      }\n    }\n  }\n}\n","@use './src/styles/abstracts/mixins' as mix;\r\n@use './src/styles/abstracts/utilities' as util;\r\n@use './src/styles/theme/theme-variables' as theme;\r\n@use 'sass:map';\r\n\r\n.mat-mdc-dialog-content {\r\n    padding: 0;\r\n    padding-right: 24px;\r\n}\r\n\r\n.help {\r\n  display: flex;\r\n\r\n  @include mix.e(search) {\r\n    background-color: #f1f1f1;\r\n    flex: 25%;\r\n    min-width: 200px;\r\n    padding: 0 24px;\r\n    width: 100%;\r\n\r\n    @include mix.c(input) {\r\n      padding-top: 2rem;\r\n    }\r\n\r\n    @include mix.c(list) {\r\n      list-style-type: none;\r\n      overflow-y: auto;\r\n      max-height: 400px;\r\n      padding: 0;\r\n\r\n      @include util.scrollbar;\r\n    }\r\n\r\n    @include mix.c(item) {\r\n      color: map.get(theme.$ascend-primary, '400');\r\n      cursor: pointer;\r\n      padding: 0.75em 0;\r\n\r\n      &:not(:last-child) {\r\n        border-bottom: 1px solid #d3d3d3;\r\n      }\r\n\r\n      &:first-child {\r\n        padding-top: 0;\r\n      }\r\n\r\n      &:last-child {\r\n        padding-bottom: 0;\r\n      }\r\n\r\n      @include mix.m(selected) {\r\n        font-weight: 500;\r\n      }\r\n\r\n      @include mix.m(none) {\r\n        font-style: italic;\r\n        color: rgb(24, 24, 24);\r\n      }\r\n    }\r\n  }\r\n\r\n  @include mix.e(result) {\r\n    flex: 75%;\r\n    padding: 2rem;\r\n  }\r\n}\r\n","@use \"sass:map\";\r\n\r\n@use './mixins' as mix;\r\n@use './variables' as var;\r\n@use './src/styles/theme/theme-variables' as theme;\r\n\r\n$displays: flex, block, inline-block, grid, inline, inline-flex, none;\r\n\r\n@each $display in $displays {\r\n  .display {\r\n    @include mix.c($display) {\r\n      display: $display !important;\r\n    }\r\n  }\r\n}\r\n\r\n.direction {\r\n  @include mix.c(column) {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n.align {\r\n  @include mix.c(items) {\r\n    @include mix.c(start) {\r\n      align-items: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      align-items: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      align-items: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      align-items: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      align-items: baseline !important;\r\n    }\r\n  }\r\n  @include mix.c(content) {\r\n    @include mix.c(start) {\r\n      align-content: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      align-content: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      align-content: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      align-content: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      align-content: baseline !important;\r\n    }\r\n    @include mix.c(between) {\r\n      align-content: space-between !important;\r\n    }\r\n    @include mix.c(around) {\r\n      align-content: space-around !important;\r\n    }\r\n  }\r\n  @include mix.c(self) {\r\n    @include mix.c(start) {\r\n      align-self: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      align-self: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      align-self: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      align-self: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      align-self: baseline !important;\r\n    }\r\n  }\r\n}\r\n\r\n.justify {\r\n  @include mix.c(items) {\r\n    @include mix.c(start) {\r\n      justify-items: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      justify-items: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      justify-items: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      justify-items: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      justify-items: baseline !important;\r\n    }\r\n  }\r\n  @include mix.c(content) {\r\n    @include mix.c(start) {\r\n      justify-content: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      justify-content: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      justify-content: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      justify-content: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      justify-content: baseline !important;\r\n    }\r\n    @include mix.c(between) {\r\n      justify-content: space-between !important;\r\n    }\r\n    @include mix.c(around) {\r\n      justify-content: space-around !important;\r\n    }\r\n  }\r\n  @include mix.c(self) {\r\n    @include mix.c(start) {\r\n      justify-content: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      justify-content: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      justify-content: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      justify-content: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      justify-content: baseline !important;\r\n    }\r\n  }\r\n}\r\n\r\n.flex {\r\n  @include mix.c(wrap) {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  @include mix.c(1) {\r\n    flex: 1 !important;\r\n  }\r\n}\r\n\r\n$positions: \"relative\", \"absolute\", \"fixed\", \"static\";\r\n@each $pos in $positions {\r\n  .position {\r\n    @include mix.c($pos) {\r\n      position: $pos !important;\r\n    }\r\n  }\r\n}\r\n\r\n.background {\r\n  @include mix.c(color) {\r\n    @include mix.m(\"white\") {\r\n      background-color: white !important;\r\n    }\r\n\r\n    @include mix.m(primary) {\r\n      background-color: map.get(theme.$ascend-primary, 500) !important;\r\n    }\r\n\r\n    @include mix.m(secondary) {\r\n      background-color: map.get(theme.$ascend-primary, 500) !important;\r\n    }\r\n\r\n    @include mix.m(success) {\r\n      $color: #becdae;\r\n      background-color: $color !important;\r\n    }\r\n\r\n    @include mix.m(muted) {\r\n      background-color: #e6e6e6 !important;\r\n    }\r\n\r\n    @include mix.m(danger) {\r\n      background-color: map.get(theme.$ascend-error, 500) !important;\r\n    }\r\n  }\r\n}\r\n\r\n$widths: (\r\n  25: 25%,\r\n  50: 50%,\r\n  75: 75%,\r\n  100: 100%,\r\n  fit: fit-content,\r\n);\r\n@each $width, $percent in $widths {\r\n  .w {\r\n    @include mix.c($width) {\r\n      width: $percent !important;\r\n    }\r\n  }\r\n}\r\n\r\n.card {\r\n  @include mix.c(spacing) {\r\n    @include mix.c(top) {\r\n      margin-top: map.get(theme.$misc-variables, \"card-spacing\") !important;\r\n    }\r\n\r\n    @include mix.c(bottom) {\r\n      margin-bottom: map.get(theme.$misc-variables, \"card-spacing\") !important;\r\n    }\r\n  }\r\n}\r\n\r\n.line-height {\r\n  @include mix.c(16) {\r\n    line-height: 1.6;\r\n  }\r\n}\r\n\r\n// Text\r\n.text {\r\n  $aligns: (left, center, right);\r\n  @each $align in $aligns {\r\n    @include mix.c($align) {\r\n      text-align: $align !important;\r\n    }\r\n  }\r\n\r\n  $sizes: (\r\n    xs: 10px,\r\n    sm: 14px,\r\n    md: 15px,\r\n    nrm: 16px,\r\n    lg: 20px,\r\n  );\r\n  @each $text, $size in $sizes {\r\n    @include mix.c($text) {\r\n      font-size: $size !important;\r\n    }\r\n  }\r\n\r\n  $styles: (normal, italic);\r\n  @each $style in $styles {\r\n    @include mix.c($style) {\r\n      font-style: $style !important;\r\n    }\r\n  }\r\n\r\n  $weights: (\r\n    normal: 400,\r\n    semibold: 600,\r\n  );\r\n  @each $text, $weight in $weights {\r\n    @include mix.c($text) {\r\n      font-weight: $weight !important;\r\n    }\r\n  }\r\n\r\n  $transforms: (\r\n    \"cap\": capitalize,\r\n    \"upper\": uppercase,\r\n    \"lower\": lowercase,\r\n  );\r\n  @each $name, $value in $transforms {\r\n    @include mix.c($name) {\r\n      text-transform: $value !important;\r\n    }\r\n  }\r\n\r\n  @include mix.c(\"white\") {\r\n    color: #fff !important;\r\n  }\r\n  @include mix.c(\"black\") {\r\n    color: rgba(0, 0, 0, 0.87) !important;\r\n  }\r\n  @include mix.c(link) {\r\n    color: #0000ff;\r\n    cursor: pointer;\r\n  }\r\n  @include mix.c(primary) {\r\n    color: map.get(theme.$ascend-primary, 500) !important;\r\n  }\r\n  @include mix.c(success) {\r\n    color: map.get(theme.$ascend-success, 500) !important;\r\n  }\r\n  @include mix.c(danger) {\r\n    color: map.get(theme.$ascend-error, 500) !important;\r\n  }\r\n  @include mix.c(muted) {\r\n    color: rgba(0, 0, 0, 0.54);\r\n  }\r\n\r\n  @include mix.c(underline) {\r\n    text-decoration: underline !important;\r\n\r\n    @include mix.c(none) {\r\n      text-decoration: none !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Border\r\n.border {\r\n  @include mix.c(0) {\r\n    border-width: 0 !important;\r\n  }\r\n\r\n  @include mix.c(none) {\r\n    border: 0px solid transparent !important;\r\n  }\r\n}\r\n\r\n// Cursor\r\n.cursor {\r\n  @include mix.c(pointer) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Page settings\r\n.page {\r\n  @include mix.c(bottom) {\r\n    @include mix.c(leeway) {\r\n      margin-bottom: 200px;\r\n    }\r\n  }\r\n}\r\n\r\n.transition {\r\n  @include mix.c(default) {\r\n    transition: 0.2s ease;\r\n  }\r\n}\r\n\r\n$overflows: (hidden, visible, auto);\r\n.overflow {\r\n  @each $overflow in $overflows {\r\n    @include mix.c($overflow) {\r\n      overflow: $overflow !important;\r\n    }\r\n  }\r\n}\r\n\r\n.box-shadow {\r\n  @include mix.m(normal) {\r\n    box-shadow: 0 0 41px -19px rgba(map.get(theme.$ascend-primary, 500), 0.3) !important;\r\n  }\r\n}\r\n\r\n// Error\r\n.mat-mdc-form-field-error {\r\n  font-size: 12px;\r\n}\r\n\r\n@mixin scrollbar {\r\n  &::-webkit-scrollbar {\r\n    width: 10px;\r\n    height: 10px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: darken(#fff, 14%);\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: darken(#fff, 38%);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
